import { api, BACKEND_URL } from './client';

// Returns the user object, or null when unauthenticated / on a transient error
// (mirrors the old authCache behaviour so callers can treat null as logged-out
// rather than surfacing an error state).
export const fetchMe = () =>
  api
    .get(`${BACKEND_URL}/api/auth/me`, { withCredentials: true })
    .then((r) => r.data || null)
    .catch(() => null);
